import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { SharepointConfigurationResponseDto } from '../dtos/sharepoint-configuration-response.dto';
import { CreateSharepointConfigurationRequestDto } from '../dtos/create-sharepoint-configuration-request.dto';
import { UpdateSharepointConfigurationRequestDto } from '../dtos/update-sharepoint-configuration-request.dto';

/**
 * SharePoint Configuration API service.
 * Handles HTTP communication with SharePoint configuration endpoint (singleton per tenant).
 */
@Injectable({ providedIn: 'root' })
export class SharepointConfigurationsApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/sharepointConfiguration`;

  /**
   * Gets the SharePoint configuration for the current tenant.
   * @returns SharePoint configuration if exists, 404 if not found
   */
  public getSharepointConfiguration(): Observable<SharepointConfigurationResponseDto> {
    return this._http.get<SharepointConfigurationResponseDto>(this._baseUrl);
  }

  /**
   * Creates SharePoint configuration for the current tenant.
   * @param request - SharePoint configuration creation request
   * @returns Created configuration ID
   */
  public createSharepointConfiguration(request: CreateSharepointConfigurationRequestDto): Observable<{ id: number }> {
    return this._http.post<{ id: number }>(this._baseUrl, request);
  }

  /**
   * Updates SharePoint configuration for the current tenant.
   * @param request - SharePoint configuration update request
   * @returns Updated configuration ID
   */
  public updateSharepointConfiguration(request: UpdateSharepointConfigurationRequestDto): Observable<{ id: number }> {
    return this._http.put<{ id: number }>(this._baseUrl, request);
  }
}
